import { useAuthStore } from '@/store/auth-store';
import { sessionScope } from '@/features/auth/session-scope';

export interface NotificationSettings {
  desktop?: boolean;
  sound?: boolean;
  mentions?: boolean;
  directMessages?: boolean;
  channels?: boolean;
  email?: boolean;
  /** The current backend returns instant and ignores attempts to edit this field. */
  emailFrequency?: string;
}
export type NotificationSettingsPatch = Omit<NotificationSettings, 'emailFrequency'>;
export const NOTIFICATION_FLAGS = ['desktop', 'sound', 'mentions', 'directMessages', 'channels', 'email'] as const;
export const EMAIL_FREQUENCIES = ['instant', 'hourly', 'daily', 'never'] as const;
export const notificationSettingsKey = () => ['notifications', 'settings', sessionScope(useAuthStore.getState())] as const;
